import { StocksApiRemoteService } from '../../Services/api/stocks/stocks-service'
import { IShowStocksByProductPayload, IShowStocksByProductResponse } from '../../Services/api/stocks/stocks.interface'
import { IFormUsecase } from '../../Shared/Protocol/protocol-form-usecase'
import { Result } from '../../Shared/Protocol/protocol-result'


export class ShowStocksByProductUseCase
implements IFormUsecase<IShowStocksByProductPayload, IShowStocksByProductResponse> {
  constructor (private readonly StocksApi: StocksApiRemoteService) {}
    

  public async handle (
    data: IShowStocksByProductPayload
  ): Promise<Result<IShowStocksByProductResponse>> {
    // eslint-disable-next-line no-useless-catch
    try {

      const response = await this.StocksApi.show(data)

      if (response.isFailure) {
        return response
      }

      const list = response.getValue()

      if(!list) return response

    
      return Result.ok(list)
    } catch (error: any) {
      return Result.fail(error)
    }
  }

 
}
